import "./NavBar.css"
function NavBar() {
  return (
    <div className="navBar">
        <div className="imgNnav">
            <img className="logo" src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/08/Netflix_2015_logo.svg/1920px-Netflix_2015_logo.svg.png" alt="logo"/>
            <div class="navs">
                <a href="#home">Home</a>
                <a href="#Action">Action</a>
                {/* TV Shows */}
                <a href="#Adventure">Adventure</a>
                {/* Movies */}
                <a href="#Comedy">Comedy</a>
                {/* My List */}
                {/* <a href="#">Browse by Languages</a> */}
            </div> 
        </div>
        <div className="rightNav">
            <img className="avatar" src="https://upload.wikimedia.org/wikipedia/commons/0/0b/Netflix-avatar.png?20201013161117" alt="avatar"/>
        </div>
        <div className="toggle">
          
        </div>
    </div>
  )
}

export default NavBar



